import { render } from "./First.vue?vue&type=template&id=27e5baec&scoped=true"
import script from "./First.vue?vue&type=script&lang=js"
export * from "./First.vue?vue&type=script&lang=js"

import "./First.vue?vue&type=style&index=0&id=27e5baec&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e5baec"]])

export default __exports__